import authTokenManager from './authToken.js';

class SecureApiClient {
  constructor() {
    this.baseURLs = {
      cloudFunctions: {
        getSheetData: process.env.REACT_APP_USE_LOCAL_FUNCTIONS === 'true'
          ? 'http://127.0.0.1:5001/therapist-online/us-central1/getSheetData'
          : 'https://getsheetdata-ccl4wg6xia-uc.a.run.app',
        updateClientTherapist: process.env.REACT_APP_USE_LOCAL_FUNCTIONS === 'true'
          ? 'http://127.0.0.1:5001/therapist-online/us-central1/updateClientTherapist'
          : 'https://updateclienttherapist-ccl4wg6xia-uc.a.run.app',
        updateClientStatus: process.env.REACT_APP_USE_LOCAL_FUNCTIONS === 'true'
          ? 'http://127.0.0.1:5001/therapist-online/us-central1/updateClientStatus'
          : 'https://updateclientstatus-ccl4wg6xia-uc.a.run.app',
        updateUserRole: process.env.REACT_APP_USE_LOCAL_FUNCTIONS === 'true'
          ? 'http://127.0.0.1:5001/therapist-online/us-central1/updateUserRole'
          : 'https://updateuserrole-ccl4wg6xia-uc.a.run.app',
        createUserProfile: process.env.REACT_APP_USE_LOCAL_FUNCTIONS === 'true'
          ? 'http://127.0.0.1:5001/therapist-online/us-central1/createUserProfile'
          : 'https://createuserprofile-ccl4wg6xia-uc.a.run.app',
        acknowledgeAgreement: process.env.REACT_APP_USE_LOCAL_FUNCTIONS === 'true'
          ? 'http://127.0.0.1:5001/therapist-online/us-central1/acknowledgeAgreement'
          : 'https://us-central1-therapist-online.cloudfunctions.net/acknowledgeAgreement',
        validateStaffInvitation: process.env.REACT_APP_USE_LOCAL_FUNCTIONS === 'true'
          ? 'http://127.0.0.1:5001/therapist-online/us-central1/validateStaffInvitation'
          : 'https://us-central1-therapist-online.cloudfunctions.net/validateStaffInvitation',
        submitClientIntake: process.env.REACT_APP_USE_LOCAL_FUNCTIONS === 'true'
          ? 'http://127.0.0.1:5001/therapist-online/us-central1/submitClientIntake'
          : 'https://us-central1-therapist-online.cloudfunctions.net/submitClientIntake',
        submitSelfAssessment: process.env.REACT_APP_USE_LOCAL_FUNCTIONS === 'true'
          ? 'http://127.0.0.1:5001/therapist-online/us-central1/submitSelfAssessment'
          : 'https://us-central1-therapist-online.cloudfunctions.net/submitSelfAssessment',
        getPortalClients: process.env.REACT_APP_USE_LOCAL_FUNCTIONS === 'true'
          ? 'http://127.0.0.1:5001/therapist-online/us-central1/getPortalClients'
          : 'https://getportalclients-ccl4wg6xia-uc.a.run.app',
        assignPortalClientTherapist: process.env.REACT_APP_USE_LOCAL_FUNCTIONS === 'true'
          ? 'http://127.0.0.1:5001/therapist-online/us-central1/assignPortalClientTherapist'
          : 'https://assignportalclienttherapist-ccl4wg6xia-uc.a.run.app',
        updatePortalClientStatus: process.env.REACT_APP_USE_LOCAL_FUNCTIONS === 'true'
          ? 'http://127.0.0.1:5001/therapist-online/us-central1/updatePortalClientStatus'
          : 'https://updateportalclientstatus-ccl4wg6xia-uc.a.run.app',
        inviteClient: process.env.REACT_APP_USE_LOCAL_FUNCTIONS === 'true'
          ? 'http://127.0.0.1:5001/therapist-online/us-central1/inviteClient'
          : 'https://inviteclient-ccl4wg6xia-uc.a.run.app',
        inviteStaff: process.env.REACT_APP_USE_LOCAL_FUNCTIONS === 'true'
          ? 'http://127.0.0.1:5001/therapist-online/us-central1/inviteStaff'
          : 'https://us-central1-therapist-online.cloudfunctions.net/inviteStaff',
        uploadClientDocument: process.env.REACT_APP_USE_LOCAL_FUNCTIONS === 'true'
          ? 'http://127.0.0.1:5001/therapist-online/us-central1/uploadClientDocument'
          : 'https://us-central1-therapist-online.cloudfunctions.net/uploadClientDocument',
        replaceClientDocument: process.env.REACT_APP_USE_LOCAL_FUNCTIONS === 'true'
          ? 'http://127.0.0.1:5001/therapist-online/us-central1/replaceClientDocument'
          : 'https://us-central1-therapist-online.cloudfunctions.net/replaceClientDocument',
        getClientDocumentUrl: process.env.REACT_APP_USE_LOCAL_FUNCTIONS === 'true'
          ? 'http://127.0.0.1:5001/therapist-online/us-central1/getClientDocumentUrl'
          : 'https://us-central1-therapist-online.cloudfunctions.net/getClientDocumentUrl',
        deleteClientDocument: process.env.REACT_APP_USE_LOCAL_FUNCTIONS === 'true'
          ? 'http://127.0.0.1:5001/therapist-online/us-central1/deleteClientDocument'
          : 'https://us-central1-therapist-online.cloudfunctions.net/deleteClientDocument',
        uploadFormTemplate: process.env.REACT_APP_USE_LOCAL_FUNCTIONS === 'true'
          ? 'http://127.0.0.1:5001/therapist-online/us-central1/uploadFormTemplate'
          : 'https://us-central1-therapist-online.cloudfunctions.net/uploadFormTemplate',
        getFormTemplateUrl: process.env.REACT_APP_USE_LOCAL_FUNCTIONS === 'true'
          ? 'http://127.0.0.1:5001/therapist-online/us-central1/getFormTemplateUrl'
          : 'https://us-central1-therapist-online.cloudfunctions.net/getFormTemplateUrl',
        deleteFormTemplate: process.env.REACT_APP_USE_LOCAL_FUNCTIONS === 'true'
          ? 'http://127.0.0.1:5001/therapist-online/us-central1/deleteFormTemplate'
          : 'https://us-central1-therapist-online.cloudfunctions.net/deleteFormTemplate',
        // Public, unauthenticated — called from the signup page before an
        // account exists. Do not call via makeSecureRequest (no token yet).
        checkExistingClient: process.env.REACT_APP_USE_LOCAL_FUNCTIONS === 'true'
          ? 'http://127.0.0.1:5001/therapist-online/us-central1/checkExistingClient'
          : 'https://us-central1-therapist-online.cloudfunctions.net/checkExistingClient'
      }
    };
  }

  // Generic secure request method
  async makeSecureRequest(url, options = {}) {
    try {
      // Get valid access token
      const token = await authTokenManager.getValidAccessToken();
      
      if (!token) {
        throw new Error('No valid authentication token available');
      }

      // Prepare request headers
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'X-Requested-With': 'XMLHttpRequest',
        ...options.headers
      };

      // Make the request
      const response = await fetch(url, {
        ...options,
        headers,
        credentials: 'include'
      });

      // Handle authentication errors
      if (response.status === 401) {
        authTokenManager.clearTokens();
        throw new Error('Authentication required. Please log in again.');
      }

      if (response.status === 403) {
        throw new Error('Access denied. You do not have permission to access this resource.');
      }

      // Handle other errors
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      throw error;
    }
  }

  // Get sheet data with authentication
  async getSheetData() {
    return this.makeSecureRequest(this.baseURLs.cloudFunctions.getSheetData, {
      method: 'GET'
    });
  }

  // Update client therapist with authentication
  async updateClientTherapist(clientId, therapist) {
    return this.makeSecureRequest(this.baseURLs.cloudFunctions.updateClientTherapist, {
      method: 'POST',
      body: JSON.stringify({
        clientId,
        therapist
      })
    });
  }

  // Update client status with authentication
  async updateClientStatus(clientId, status) {
    return this.makeSecureRequest(this.baseURLs.cloudFunctions.updateClientStatus, {
      method: 'POST',
      body: JSON.stringify({
        clientId,
        status
      })
    });
  }

  // Update user role with authentication (admin only)
  async updateUserRole(userId, role) {
    return this.makeSecureRequest(this.baseURLs.cloudFunctions.updateUserRole, {
      method: 'POST',
      body: JSON.stringify({
        userId,
        role
      })
    });
  }

  // Create user profile with authentication
  async createUserProfile(firstName, lastName, options = {}) {
    return this.makeSecureRequest(this.baseURLs.cloudFunctions.createUserProfile, {
      method: 'POST',
      body: JSON.stringify({
        firstName,
        lastName,
        ...options
      })
    });
  }

  async acknowledgeAgreement(agreement) {
    return this.makeSecureRequest(this.baseURLs.cloudFunctions.acknowledgeAgreement, {
      method: 'POST',
      body: JSON.stringify({ agreement })
    });
  }

  // Generic POST request
  async post(url, data) {
    return this.makeSecureRequest(url, {
      method: 'POST',
      body: JSON.stringify(data)
    });
  }

  // Generic GET request
  async get(url) {
    return this.makeSecureRequest(url, {
      method: 'GET'
    });
  }

  // Generic PUT request
  async put(url, data) {
    return this.makeSecureRequest(url, {
      method: 'PUT',
      body: JSON.stringify(data)
    });
  }

  // Generic DELETE request
  async delete(url) {
    return this.makeSecureRequest(url, {
      method: 'DELETE'
    });
  }

  // Upload file with authentication
  async uploadFile(url, file, onProgress = null) {
    try {
      const token = await authTokenManager.getValidAccessToken();
      
      if (!token) {
        throw new Error('No valid authentication token available');
      }

      const formData = new FormData();
      formData.append('file', file);

      const xhr = new XMLHttpRequest();
      
      return new Promise((resolve, reject) => {
        xhr.upload.addEventListener('progress', (event) => {
          if (onProgress && event.lengthComputable) {
            const percentComplete = (event.loaded / event.total) * 100;
            onProgress(percentComplete);
          }
        });

        xhr.addEventListener('load', () => {
          if (xhr.status === 200) {
            try {
              const response = JSON.parse(xhr.responseText);
              resolve(response);
            } catch (error) {
              resolve(xhr.responseText);
            }
          } else {
            reject(new Error(`Upload failed with status: ${xhr.status}`));
          }
        });

        xhr.addEventListener('error', () => {
          reject(new Error('Upload failed'));
        });

        xhr.open('POST', url);
        xhr.setRequestHeader('Authorization', `Bearer ${token}`);
        xhr.send(formData);
      });
    } catch (error) {
      throw error;
    }
  }
}

// Create singleton instance
const secureApiClient = new SecureApiClient();

export default secureApiClient;
